module.exports = __webpack_public_path__ + "static/media/9S.46304258.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/9S.svg
// module id = 84
// module chunks = 0